import React from 'react';
import { Clock, TrendingUp, BrainCircuit } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-16 md:py-24 px-4 bg-cream" data-id="element-584" data-mp="2sjcao8k4pyk8">
      <div className="max-w-4xl mx-auto" data-id="element-585" data-mp="2sgq1y5li5d0f">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-12 text-center" data-id="element-586" data-mp="36azhh2bp6ph9">
          ⏰ Por Qué Decidir Ahora
        </h2>

        <div className="space-y-8" data-id="element-587" data-mp="31h4p7ai1126k">
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border-l-4 border-urgency flex flex-col md:flex-row gap-6 items-start" data-id="element-588" data-mp="3g7lzljcn32fl">
            <div className="bg-urgency/10 p-4 rounded-full shrink-0" data-id="element-589" data-mp="3b8is7s96sk4g">
              <TrendingUp className="text-urgency" size={32} data-id="element-590" data-mp="3p93b0of3qfxy" />
            </div>
            <div data-id="element-591" data-mp="3l7hw6xj0brl4">
              <h3 className="text-xl font-bold text-dark mb-3" data-id="element-592" data-mp="3l6yjbv87rtdy">
                Razón #1: El Precio Sube
              </h3>
              <p className="text-dark/80 leading-relaxed" data-id="element-593" data-mp="1uvask5evvgdt">
                Este es el precio de lanzamiento. Una vez que se superen las
                primeras unidades vendidas, el precio vuelve a $54.696 ARS. No
                es un truco de marketing. Es la política de lanzamiento real.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border-l-4 border-forest flex flex-col md:flex-row gap-6 items-start" data-id="element-594" data-mp="32ru7jzyqfpe1">
            <div className="bg-forest/10 p-4 rounded-full shrink-0" data-id="element-595" data-mp="37jcbmww1y638">
              <Clock className="text-forest" size={32} data-id="element-596" data-mp="3ci6shtaglkkp" />
            </div>
            <div data-id="element-597" data-mp="3cjzyd6d900rn">
              <h3 className="text-xl font-bold text-dark mb-3" data-id="element-598" data-mp="3giz2wpv2hvik">
                Razón #2: Cada Noche Que Pasa Es Una Noche Perdida
              </h3>
              <p className="text-dark/80 leading-relaxed" data-id="element-599" data-mp="3liv6inzurkxl">
                La inflamación crónica no toma días libres. Cada noche que cenas
                de la misma manera, acumulas un ciclo inflamatorio más. El mejor
                momento para empezar fue hace un año. El segundo mejor momento
                es esta noche.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border-l-4 border-gold flex flex-col md:flex-row gap-6 items-start" data-id="element-600" data-mp="1o3hcajuf1n6u">
            <div className="bg-gold/20 p-4 rounded-full shrink-0" data-id="element-601" data-mp="1k374r2qz6opv">
              <BrainCircuit className="text-gold-dark" size={32} data-id="element-602" data-mp="1y1ou14wj499w" />
            </div>
            <div data-id="element-603" data-mp="1t0r9wmryl55r">
              <h3 className="text-xl font-bold text-dark mb-3" data-id="element-604" data-mp="1t07sd7680is9">
                Razón #3: Tu Cuerpo Tiene Memoria
              </h3>
              <p className="text-dark/80 leading-relaxed" data-id="element-605" data-mp="26z7h0etqgxof">
                Cuanto más tiempo permanece el sistema inflamatorio activado,
                más tiempo tarda en regularse. Empezar hoy significa resultados
                esta semana. Esperar un mes significa empezar desde más atrás.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}